import React, { useState, useEffect } from 'react'

interface SessionCountdownProps {
  seconds: number
  onExpired: () => void
  onCancel: () => void
}

export const SessionCountdown: React.FC<SessionCountdownProps> = ({ seconds, onExpired, onCancel }) => {
  const [remaining, setRemaining] = useState(seconds)

  useEffect(() => {
    if (remaining <= 0) {
      onExpired()
      return
    }
    const timer = setInterval(() => setRemaining(r => r - 1), 1000)
    return () => clearInterval(timer)
  }, [remaining, onExpired])

  const pct = (remaining / seconds) * 100

  return (
    <div className="mx-4 my-2 px-4 py-3 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 animate-slide-up">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <svg className="w-4 h-4 text-amber-500 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm font-semibold text-amber-700 dark:text-amber-300">
            Session ending in {remaining}s
          </span>
        </div>
        <button onClick={onCancel} className="text-xs font-medium text-amber-600 hover:text-amber-800 dark:text-amber-400 transition-colors">
          Cancel
        </button>
      </div>
      <div className="w-full h-1.5 bg-amber-200 dark:bg-amber-800 rounded-full overflow-hidden">
        <div className="h-full bg-amber-500 rounded-full transition-all duration-1000" style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}
